'use strict';

const AbstractContent = require('./AbstractContent');

/**
 * Content class is used for all content except container
 *
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
class Content extends AbstractContent {
}

module.exports = Content;
